<!-- Loads either the layout.component.ts or pages/auth.routing.ts -->
<router-outlet></router-outlet>
